
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, FormText, Input, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { createSlider, deleteSlider, getAllSliders, toggleSlider, updateSlider } from '../../../../redux/admin/promotion/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { getAllCities } from '../../../../redux/admin/cities/actions';
import { getAllItems } from '../../../../redux/admin/item/action';
import noimage from '../../../../assets/images/noimage.png'
import { Image, Table } from 'antd';
import { getAllStoreCategories, getAllStores } from "../../../../redux/admin/store/action";
import { ColorRing } from 'react-loader-spinner';

const Sliders = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllSliders()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false);
            }
        })
        dispatch(getAllCities());
        dispatch(getAllItems());
        dispatch(getAllStores());
        dispatch(getAllStoreCategories());
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        sliders: state.promotion.sliders,
        store_categories: state.store.store_categories,
        cities: state.cities.cities,
        stores: state.store.stores,
        items: state.item.items.data,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,

    });
    const { store_categories, sliders, stores, items, cities, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [loading, setLoading] = useState(true);

    const [editingSlider, setEditingSlider] = useState([]);   //edit category state

    const [deletingSlider, setDeletingSlider] = useState([]);   //delete category state

    const [formData, setFormData] = useState([]);   //form data state defined

    const [showToast, setShowToast] = useState(false);   //toast state

    const [data, setData] = useState([]);  //data state defined

    const [sliderType, setSliderType] = useState([]);  //isMultiple state defined

    const [selectedStores, setSelectedStores] = useState([]);  //isMultiple state defined
    const [cityId, setCityId] = useState([]);  //data state defined
    const [image, setImage] = useState([]);  // state defined

    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
    });

    // ---------------Start multi select Stores ------------

    const getSelectedStores = (stores) => {
        const allStores = [];
        const selectedStores = [];
        const storeIds = [];
        if (modal.edit) {
            editingSlider.stores.map((selected_stores) => (
                storeIds.push(selected_stores.id)
            ))
        }
        let selected = stores.forEach((store) => {
            let selected_user = storeIds.includes(store.id)
            if (selected_user) {
                allStores.push(store);
            }
        });

        allStores?.forEach((element) => {
            const dataObj = {
                value: element.id,
                label: element.name,
            };
            selectedStores.push(dataObj);
        });
        return selectedStores;
    };
    const getStoresDropDown = (stores) => {
        const allStores = [];
        stores.forEach((element) => {
            if (cityId == element.city_id) {
                const dataObj = {
                    value: element.id,
                    label: element.name,
                };
                allStores.push(dataObj);
            }
        });
        return allStores;
    };
    // ---------------End multi select Stores ------------
    // ---------------Start multi select items ------------
    const getSelectedItems = (items) => {
        const allItems = [];
        const selectedItems = [];
        const itemsIds = [];
        if (modal.edit) {
            editingSlider.items.map((selected_items) => (
                itemsIds.push(selected_items.id)
            ))
        }
        let selected = items.forEach((item) => {
            let selected_user = itemsIds.includes(item.id)
            if (selected_user) {
                allItems.push(item);
            }
        });
        allItems?.forEach((element) => {
            const dataObj = {
                value: element.id,
                label: element.name,
            };
            selectedItems.push(dataObj);
        });
        return selectedItems;
    };
    const getItemsDropDown = (items) => {
        const allItems = [];
        items.forEach((element) => {
            if (element.store && element.store.city_id == cityId) {
                const dataObj = {
                    value: element.id,
                    label: element.name,
                };
                allItems.push(dataObj);
            }
        });
        return allItems;
    };

    // ---------------End multi select items ------------

    //to open add modal
    const openAddModal = () => {
        setEditingSlider([]);
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
    };

    //to open edit modal
    const openEditModal = (category) => {
        setModal({ edit: true });
        dispatch(nonActiveFormSubmissionStatus());
        setEditingSlider(category);
        setSelectedStores(category.stores?.map((store) => (
            { value: store.id, label: store.name }
        )))
        setCityId(category.city_id)
        setSliderType(category.type)
    };

    //to open delete modal
    const openDeleteModal = (category) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingSlider(category);
    };

    //store lists
    const listCities = cities?.map((city) => (
        { value: city.id, label: city.name }
    ));
    const AllStores = stores?.map((store) => (
        { value: store.id, label: store.name }
    ));
    const listStoreCategories = store_categories?.map((city) => (
        { value: city.id, label: city.name }
    ));
    const types = [
        // { value: 'SINGLE_STORE', label: 'Single Store' },
        { value: 'MULTI_STORE', label: 'Multi Store' },
        { value: 'ITEM', label: 'Item' }
    ];


    //form validation with yup
    const categorySchema = yup.object({
        name: yup.string().required(),
        radius: yup.string().required(),
        latitude: yup.string().required(),
        longitude: yup.string().required(),
        city_id: yup.string().required(),
        store_id: yup.string(),
        store_ids: yup.array(),
        item_ids: yup.array(),
        type: yup.string(),
        store_category_id: yup.string().required(),

    });

    //form values
    const defaultValues = useMemo(
        () => ({
            id: editingSlider?.id || "",
            name: editingSlider?.name || "",
            radius: editingSlider?.radius || "",
            latitude: editingSlider?.latitude || "",
            longitude: editingSlider?.longitude || "",
            store_category_id: editingSlider?.store_category_id || "",
            type: editingSlider?.type || "",
            city_id: editingSlider?.city_id || "",
            store_id: editingSlider?.store_id || "",
            store_ids: editingSlider?.store_ids || [],
            item_ids: editingSlider?.item_ids || [],

        }),
        [editingSlider]
    );

    //form methods
    const methods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    //submit function
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        let store_ids = JSON.stringify(submitData?.store_ids);
        let item_ids = JSON.stringify(submitData?.item_ids);
        const new_data = new FormData();
        new_data.append('id', editingSlider?.id);
        new_data.append('name', submitData?.name);
        new_data.append('token', localStorage.getItem('accessToken'));
        if (image) {
            new_data.append('image', image);
        }
        new_data.append('radius', submitData?.radius);
        new_data.append('latitude', submitData?.latitude);
        new_data.append('longitude', submitData?.longitude);
        new_data.append('store_category_id', submitData?.store_category_id);
        new_data.append('type', submitData?.type);
        new_data.append('city_id', submitData?.city_id);
        new_data.append('store_id', submitData?.store_id);
        new_data.append('store_ids', store_ids);
        new_data.append('item_ids', item_ids);
        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateSlider(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createSlider(new_data));
        } else if (modal.delete) {
            dispatch(deleteSlider(deletingSlider?.id));
        }
        resetForm();
    };

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            radius: "",
            latitude: "",
            longitude: "",
            store_category_id: "",
            type: "",
            city_id: "",
            store_id: "",
            store_ids: [],
            item_ids: [],

        });
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        document.getElementByClass("invalid").innerHTML = "";
        resetForm();
    };

    //category toggle
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleSlider(id));
        setTimeout(() => {
            dispatch(getAllSliders());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllSliders());
                setData(sliders);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingSlider && form_loading == false && form_submission_status == true) {
            dispatch(getAllSliders());
            setData(sliders);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllSliders());
                setData(sliders);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createSlider, form_loading, modal, form_submission_status]);

    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            width: "15vh",
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Latitude",
            selector: (row) => row.latitude,
            sortable: true,
        },
        {
            name: "Longitude",
            selector: (row) => row.longitude,
            sortable: true,
        },
        {
            name: "Radius",
            selector: (row) => row.radius,
            sortable: true,
        },
        {
            name: "City",
            selector: (row) => row.city?.name,
            sortable: true,
        },

        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];


    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a"
                                href="#dropdownitem"
                                onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Sliders"></Head>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Sliders
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {sliders?.length} sliders.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample
                                            show={showToast}
                                        />
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                {/* <li>
                                            <a
                                                href="#export"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                                className="btn btn-white btn-outline-light"
                                            >
                                                <Icon name="download-cloud"></Icon>
                                                <span>Export</span>
                                            </a>
                                        </li> */}
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={sliders} columns={dataTableColumns} expandableRows pagination />
                    </Content>

                    {/* add and edit modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing Slider - " + editingSlider?.name : "Add Slider"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label">Slider Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Slider Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="" id={editingSlider.id}>
                                                    {editingSlider?.image ?
                                                        <Image src={editingSlider.image} alt="banner" style={{ objectFit: 'cover', height: '20vh' }} />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item category" style={{ height: '20vh', }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" >Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                                <FormText>Upload resolution 2500x1390 pixel</FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Radius</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="radius"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter city maximum delivery radius"
                                                />
                                                {errors.radius && <span className="invalid">{errors.radius.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Latitude </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="latitude"
                                                    placeholder="Enter City Latitude"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                />
                                                {errors.latitude && <span className="invalid">{errors.latitude.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Longitude</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="longitude"
                                                    placeholder="Enter City Longitude"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.longitude && <span className="invalid">{errors.longitude.message}</span>}
                                            </FormGroup>
                                        </Col>

                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Category</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_category_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listStoreCategories}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={listStoreCategories.find((city) => city.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.store_category_id && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Store</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">City</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="city_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listCities}
                                                                onChange={(val) => {
                                                                    onChange(val.value)
                                                                    setCityId(val.value)
                                                                }}
                                                                defaultValue={listCities.find((city) => city.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.city_id && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Store</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" >
                                            <FormGroup>
                                                <label className="form-label">Type</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="type"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={types}
                                                                onChange={(val) => {
                                                                    onChange(val.value)
                                                                    setSliderType(val.value)
                                                                }}
                                                                defaultValue={types.find((type) => type.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.type && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Type</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        <Col md="12" style={sliderType == "MULTI_STORE" || sliderType == "SINGLE_STORE" ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Banner Applicable Store :</label>
                                                {sliderType == "MULTI_STORE" ? (
                                                    <div className="form-control-wrap">
                                                        <Controller
                                                            name="store_ids"
                                                            control={control}
                                                            render={({ onChange, value }) => (
                                                                <RSelect
                                                                    options={getStoresDropDown(stores)}
                                                                    isMulti
                                                                    onChange={(val) => onChange(val.map((c) => c.value))}
                                                                    defaultValue={getSelectedStores(stores)}
                                                                ></RSelect>
                                                            )}
                                                        />
                                                    </div>
                                                ) : sliderType == "SINGLE_STORE" ? (
                                                    <div className="form-control-wrap">
                                                        <Controller
                                                            name="store_id"
                                                            control={control}
                                                            render={({ onChange, value }) => (
                                                                <RSelect
                                                                    options={AllStores}
                                                                    onChange={(val) => {
                                                                        onChange(val.value)
                                                                    }}
                                                                    defaultValue={selectedStores && AllStores.find((store) => store.value == selectedStores[0]?.value)}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                ) : ""}
                                            </FormGroup>
                                        </Col>

                                        <Col md="12" style={sliderType == "ITEM" ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Banner Applicable Item :</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="item_ids"
                                                        control={control}
                                                        render={({ onChange, value }) => (
                                                            <RSelect
                                                                options={getItemsDropDown(items)}
                                                                isMulti
                                                                onChange={(val) => onChange(val.map((c) => c.value))}
                                                                defaultValue={getSelectedItems(items)}
                                                            ></RSelect>
                                                        )}
                                                    />
                                                </div>

                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> {modal.edit ? "Updating Slider" : "Creating New Slider"}
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Slider" : "Add New Slider"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a href="#cancel" onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                        className="link link-light"   >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ delete: false })}
                        className="modal-dialog-centered"
                    // size="lg"
                    >
                        <ModalBody className='pt-3 pb-2'>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Delete Slider{' '}
                                    <Badge color="primary">
                                        {deletingSlider?.name}
                                    </Badge>
                                    {' '}
                                    ?
                                </h5>
                                <div className='mt-2'>
                                    <span>This Item category will be deleted. Do you really want to delete this category ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button onClick={(e) => {
                                                e.preventDefault();
                                                onFormSubmit();
                                            }} color="danger" className="px-4 btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>

    );
}

export default Sliders
